import { transitionForms } from "./taskConfig";

export type ReviewerRoleKey = "vm" | "cm" | "bizfin" | "compliance";

// Form-name keys per role in task_config.transition_forms, used to resolve
// reviewer decision/remarks form IDs at runtime. Beta uses vm_remarks for VM
// and <role>_decision for CM/BizFin/Compliance; both variants are listed per
// role for env portability (callers dedupe resolved form IDs).
export const REVIEWER_TRANSITION_KEYS: Record<ReviewerRoleKey, string[]> = {
  vm: ["vm_remarks", "vm_decision"],
  cm: ["cm_decision", "cm_remarks"],
  bizfin: ["bizfin_decision", "bizfin_remarks"],
  compliance: ["compliance_decision", "compliance_remarks"],
};

export const REVIEWER_APPROVED_MSG: Record<ReviewerRoleKey, string> = {
  vm: "VM enrichment submitted. Task handed off to the Category Manager for review.",
  cm: "Category Manager decision recorded. Task handed off to the next reviewer.",
  bizfin:
    "Business Finance decision recorded. Task handed off to the next reviewer.",
  compliance:
    "Compliance decision recorded. Vendor onboarding is being activated.",
};

export const REVIEWER_REJECTED_MSG =
  "Task rejected and returned to the vendor.";
export const REVIEWER_SEND_BACK_MSG_TO_VENDOR =
  "Task sent back to the vendor for changes.";
export const REVIEWER_SEND_BACK_MSG_TO_VM =
  "Task sent back to the Vendor Manager for rework.";

export const REVIEWER_REMARKS_FIELD: Record<ReviewerRoleKey, string> = {
  vm: "vm_remarks",
  cm: "category_manager_remarks",
  bizfin: "biz_fin_remarks",
  compliance: "compliance_remarks",
};

export function reviewerFormId(
  taskConfig: unknown,
  role: ReviewerRoleKey,
): string | undefined {
  const tf = transitionForms(taskConfig);
  if (!tf) return undefined;
  for (const key of REVIEWER_TRANSITION_KEYS[role]) {
    if (tf[key]) return tf[key];
  }
  return undefined;
}
